var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewyearBurger24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17C2.67157 17 2 17.6716 2 18.5C2 19.3284 2.67157 20 3.5 20H20.5C21.3284 20 22 19.3284 22 18.5C22 17.6716 21.3284 17 20.5 17H3.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5C2 10.6716 2.67157 10 3.5 10H20.5C21.3284 10 22 10.6716 22 11.5C22 12.3284 21.3284 13 20.5 13H3.5C2.67157 13 2 12.3284 2 11.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5C2 3.67157 2.67157 3 3.5 3H20.5C21.3284 3 22 3.67157 22 4.5C22 5.32843 21.3284 6 20.5 6H3.5C2.67157 6 2 5.32843 2 4.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3284 20H7.67157L10.6716 17H16.3284L13.3284 20ZM19.1716 17H20.5C21.3284 17 22 17.6716 22 18.5C22 19.3284 21.3284 20 20.5 20H16.1716L19.1716 17ZM7.82843 17L4.82843 20H3.5C2.67157 20 2 19.3284 2 18.5C2 17.6716 2.67157 17 3.5 17H7.82843Z",
    fill: "url(#paint0_linear_1_394)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1715 10H20.5C21.3284 10 22 10.6716 22 11.5C22 12.3284 21.3284 13 20.5 13H16.1715L19.1715 10ZM16.3285 10L13.3285 13H7.6716L10.6716 10H16.3285ZM7.82839 10L4.82839 13H3.5C2.67157 13 2 12.3284 2 11.5C2 10.6716 2.67157 10 3.5 10H7.82839Z",
    fill: "url(#paint1_linear_1_394)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3284 6H7.67157L10.6716 3H16.3284L13.3284 6ZM19.1716 3H20.5C21.3284 3 22 3.67157 22 4.5C22 5.32843 21.3284 6 20.5 6H16.1716L19.1716 3ZM7.82843 3L4.82843 6H3.5C2.67157 6 2 5.32843 2 4.5C2 3.67157 2.67157 3 3.5 3H7.82843Z",
    fill: "url(#paint2_linear_1_394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_394",
    x1: 2,
    y1: 17,
    x2: 2.8802,
    y2: 22.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_394",
    x1: 2,
    y1: 10,
    x2: 2.8802,
    y2: 15.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_394",
    x1: 2,
    y1: 3,
    x2: 2.8802,
    y2: 8.86797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewyearBurger24);
export default __webpack_public_path__ + "static/media/newyear-burger_24.89a25314.svg";
export { ForwardRef as ReactComponent };